import { render, staticRenderFns } from "./ModalResponseMassive.vue?vue&type=template&id=236a9de4"
import script from "./ModalResponseMassive.vue?vue&type=script&lang=js"
export * from "./ModalResponseMassive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports